import PhotoSwipeLightbox from './photoswipe-lightbox.esm.min.js';
import PhotoSwipe from './photoswipe.esm.min.js';

// One gallery serves both product layouts and the mobile carousel.
class ZoomAction extends HTMLElement {
  connectedCallback() {
    this.type = this.dataset.type || 'no_zoom';
    this.zoomOption = this.dataset.zoomOption || 'inner-1';
    this.drifts = [];
    this.hoverEnabled = false;
    this.onResize = this.updateZoom.bind(this);

    // Delegated clicks keep the correct image index when variants or video
    // slides change the carousel. PhotoSwipe supplies close, zoom and swipe UI.
    this.lightbox = new PhotoSwipeLightbox({
      gallery: this,
      children: 'a.media-gallery__image[href]',
      pswpModule: () => PhotoSwipe,
      bgOpacity: 0.96,
      loop: false,
    });
    this.lightbox.init();

    window.addEventListener('resize', this.onResize);
    window.addEventListener('load', this.onResize, { once: true });
    this.updateZoom();
  }

  updateZoom() {
    const desktopHover = window.innerWidth >= 768 &&
      window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    const shouldZoom = desktopHover &&
      !['no_zoom', 'open_lightbox'].includes(this.type) &&
      typeof window.Drift === 'function';

    if (shouldZoom === this.hoverEnabled) return;
    this.hoverEnabled = shouldZoom;
    this.drifts.forEach((drift) => drift.destroy());
    this.drifts = [];
    if (!shouldZoom) return;

    const externalPane = this.zoomOption === 'external'
      ? this.closest('.sec__featured-product')?.querySelector('.zoom-external-area')
      : null;

    this.querySelectorAll('a.media-gallery__image[href] .drift-trigger').forEach((trigger) => {
      const imageLink = trigger.closest('a.media-gallery__image[href]');
      if (!imageLink) return;
      // Drift needs the original image rather than the smaller responsive src.
      trigger.setAttribute('data-zoom-src', imageLink.href);
      this.drifts.push(new window.Drift(trigger, {
        sourceAttribute: 'data-zoom-src',
        zoomFactor: 2.5,
        inlinePane: externalPane ? false : 180,
        inlineContainer: imageLink,
        containInline: true,
        paneContainer: externalPane || imageLink,
        boundingBoxContainer: imageLink,
        hoverBoundingBox: Boolean(externalPane),
        handleTouch: false,
      }));
    });
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('load', this.onResize);
    this.drifts?.forEach((drift) => drift.destroy());
    this.drifts = [];
    this.lightbox?.destroy();
    this.lightbox = null;
  }
}

customElements.define('zoom-action', ZoomAction);
